export var PERFORMANCE_ENTRY_TYPES;
(function (PERFORMANCE_ENTRY_TYPES) {
    PERFORMANCE_ENTRY_TYPES["RESOURCE"] = "resource";
    PERFORMANCE_ENTRY_TYPES["PAINT"] = "paint";
    PERFORMANCE_ENTRY_TYPES["LARGEST_CONTENTFUL_PAINT"] = "largest-contentful-paint";
    PERFORMANCE_ENTRY_TYPES["LAYOUT_SHIFT"] = "layout-shift";
    PERFORMANCE_ENTRY_TYPES["LONG_TASK"] = "longtask";
    PERFORMANCE_ENTRY_TYPES["FIRST_INPUT"] = "first-input";
})(PERFORMANCE_ENTRY_TYPES || (PERFORMANCE_ENTRY_TYPES = {}));
